import React from 'react';
import PropTypes from 'prop-types';
import { ConnectedRouter } from 'connected-react-router';
import Routes from './Routes';
import { connect } from "react-redux";
import Header from './Header';
import {createRoutesForUser} from '../actions/generalActions';

class App extends React.Component {

  componentDidMount() {
    const { createRoutesForUser, role } = this.props;
      createRoutesForUser(role);
  }

  componentDidUpdate(prevProps) {
    const { createRoutesForUser, role  } = this.props;
    if (prevProps.role !== role)
    createRoutesForUser(role);
  }

  render() {
    const { history, role, isLoadingUser, general } = this.props;

      return (
        !isLoadingUser &&
          <ConnectedRouter history={history}>
           <React.Fragment>
              <Header />
              <Routes role={role} allowedRoutes={general.routes}/>
            </React.Fragment>
        </ConnectedRouter>
    );
  };
}

App.propTypes = {
  history: PropTypes.object,
  role: PropTypes.string,
  createRoutesForUser: PropTypes.func,

};

function mapStateToProps(state) {
  return {
    isLoadingUser: state.oidc.isLoadingUser,
    user: state.oidc.user,
    role: (state.oidc.user && state.oidc.user.profile) ? state.oidc.user.profile.identity_role : null,
    general: state.general,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    createRoutesForUser: (userRole) => {dispatch(createRoutesForUser(userRole))}
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js